/**
 * Interface for dimension parameter type descriptors. These affect the behavior of the parameter card appearance on the Configurator.
 */
interface IDimensionsTypeDescriptor {
    [name: string]: {
        label?: string;
        tooltip?: string;
        editable?: boolean;
        readOnly?: boolean;
        placeholder?: string;
        units?: {
            [unitName: string]: {
                min?: number;
                max?: number;
                value?: number;
                default?: number;
                decimals?: number;
                largeStep?: number;
                smallStep?: number;
            }
        }
    }
}

export default IDimensionsTypeDescriptor;
